module.exports = __webpack_public_path__ + "static/assets/e5c63221bbefc5554a1ecbbba8a0f342.png";